import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from '@mui/styles';

import FlagstoneTheme from './Config/flagstoneTheme';
import IndexPage from './Components/Pages/Nav/IndexPage';
import * as Actions from './Reducers/actions.js';
import 'react-toastify/dist/ReactToastify.css';
import AuthProvider from './Helpers/auth.provider'
import ApiHelper from './Helpers/apiHelper';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appSettings: null,
      workstation: null,
    }
  }

  componentDidMount = () => {

    fetch("appsettings.json").then(
      function (res) {
        return res.json()
      }).then((data) => {
        ApiHelper.appSettings = data;

        this.setState({ appSettings: data });
      }).catch(
        function (err) {
          console.log(err, ' error');
        }
      )
  }

  render() {
    return (
      <ThemeProvider theme={FlagstoneTheme}>
        {this.state.appSettings &&
          <AuthProvider appSettings={this.state.appSettings}>
            <Router basename={`${process.env.PUBLIC_URL}`} >
              <IndexPage {...this.props} appSettings={this.state.appSettings}></IndexPage>
            </Router>
          </AuthProvider>
        }
        <ToastContainer />
      </ThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  nav: state.nav,
  workstation: state.workstation,
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
})

export default compose(withTranslation(), connect(
  mapStateToProps,
  mapDispatchToProps
))(App);
